function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.6797,
  cy: 51.8608,
  rx: 23,
  ry: 1.5,
  fill: "#3E5C69"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9106 35.2959C19.3623 33.5648 20.8917 32.3608 22.639 32.3608H34.7203C36.4677 32.3608 37.9971 33.5648 38.4488 35.2959L41.54 47.1422C42.2272 49.7755 40.2922 52.3608 37.6342 52.3608H19.7252C17.0672 52.3608 15.1322 49.7755 15.8194 47.1422L18.9106 35.2959ZM32.1797 49.3608C35.2172 49.3608 37.6797 46.8984 37.6797 43.8608C37.6797 40.8233 35.2172 38.3608 32.1797 38.3608C29.1421 38.3608 26.6797 40.8233 26.6797 43.8608C26.6797 46.8984 29.1421 49.3608 32.1797 49.3608Z",
  fill: "#4C86B7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.6797,
  cy: 46.3608,
  r: 2,
  fill: "#3E5C69"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.6935 31.2595L11.9238 43.7534L11.6852 42.5062L11.3118 40.5103L9.67478 31.8786L8.20811 24.1372L7.24265 19.043L5.77819 11.306L4.97419 7.06072C4.56917 3.55922 8.74506 1.45289 11.3202 3.85976L12.4613 5.08804L12.4639 5.09316L14.2564 7.02955L19.6037 12.8081L23.1266 16.6123L28.4813 22.3926L30.7179 24.8098L36.6935 31.2595Z",
  fill: "#F5841F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.10138 43.0879L6.36064 48.5279C6.04285 49.1586 6.08131 49.9102 6.46184 50.5053L7.35846 51.9073L22.9002 46.5187C23.3099 46.3766 23.6994 46.1819 24.0589 45.9393L38.3751 36.2798L42.7553 30.7077L42.2999 29.0316C41.968 27.8102 40.5993 27.2003 39.4691 27.7703L9.10138 43.0879Z",
  fill: "#F5841F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.6033 12.8075L7.24219 19.0425L5.77773 11.3054L14.2567 7.02863L19.6033 12.8075Z",
  fill: "#ECECEC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4808 22.3919L9.67432 31.8779L8.20765 24.1365L23.1262 16.6116L28.4808 22.3919Z",
  fill: "#ECECEC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7077 42.2032C13.1899 42.1289 15.6085 41.6358 17.9496 40.9472C20.2883 40.2433 22.5428 39.2977 24.7011 38.1632C25.7504 37.5432 26.8391 36.9867 27.8325 36.2721C28.3378 35.9292 28.8663 35.6177 29.3536 35.25C29.8369 34.8742 30.3257 34.5058 30.8177 34.1403C31.0615 33.9531 31.3142 33.778 31.5503 33.5828L32.2465 32.9805L33.6543 31.7865C34.5719 30.9634 35.4369 30.0835 36.3732 29.2574C35.6142 30.2369 34.844 31.2194 34.0198 32.1548L32.7117 33.4939L32.0508 34.159C31.8236 34.3735 31.579 34.5684 31.3441 34.7749C30.8712 35.1839 30.3939 35.5896 29.9107 35.9892C29.4264 36.3865 28.8984 36.728 28.3935 37.1009C27.3894 37.8576 26.2726 38.442 25.1992 39.0943C22.9638 40.2467 20.6093 41.1831 18.1584 41.7429C15.7181 42.2983 13.1769 42.5682 10.7077 42.2032Z",
  fill: "black",
  fillOpacity: 0.38
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M11.7729 42.2024C11.7729 42.2024 13.4063 41.7662 15.0413 41.6986C19.5471 41.5148 26.9266 38.4928 33.5028 32.2592C34.0584 31.7324 35.0852 30.8588 35.4794 30.1503L34.4303 28.8481C34.4303 28.8481 15.9814 32.2831 5.26424 8.72445L5.755 11.3165L7.22384 19.0514L8.1893 24.1455L9.65597 31.887L11.7729 42.2024Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  fill: "white",
  transform: "translate(0.5)"
})));

function SvgEmptyMonster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMonster);
export default __webpack_public_path__ + "static/media/empty_monster.2709dfb2.svg";
export { ForwardRef as ReactComponent };